import { render, staticRenderFns } from "./SimulatedExamConfig.vue?vue&type=template&id=423e4502&scoped=true"
import script from "./SimulatedExamConfig.vue?vue&type=script&lang=js"
export * from "./SimulatedExamConfig.vue?vue&type=script&lang=js"
import style0 from "./SimulatedExamConfig.vue?vue&type=style&index=0&id=423e4502&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423e4502",
  null
  
)

export default component.exports